import Cookies from 'js-cookie'
import { getStateFromCookies as getStateFromCookiesReduxMiddleware } from 'redux-cookies-middleware';

const getPrefixedName = (name, secure) => {
  return secure ? `__Host-${name}` : name;
};

export const getCookie = (name, secure = false) => {
  return Cookies.get(getPrefixedName(name, secure));
};

export const getStateFromCookies = (preloadedState = {}, paths) => {
  const isProd = process.env.NODE_ENV === 'production'
  console.log('getStateFromCookies: request: secure: ', isProd, 'paths', paths);
  let response = getStateFromCookiesReduxMiddleware(
    preloadedState,
    paths,
    (name) => getCookie(name, isProd)   // ← uses __Host- in PROD
  );
  console.log('getStateFromCookies: response:', response);
  return response
}


/**
 * Custom setCookie that matches redux-cookies-middleware expected signature
 * @param {string} name - Cookie name
 * @param {string} value - Cookie value (already JSON.stringify'd by middleware)
 * @param {boolean} secure - Whether to use secure cookie (with __Host- prefix)
 * @param {string} sameSite - SameSite attribute for the cookie
 * @param {boolean} httpOnly - HttpOnly attribute for the cookie
 */
export const setCookie = (
  name,
  value,
  secure = true,
  sameSite = 'lax',
  httpOnly=false
) => {
    const cookieName = getPrefixedName(name, secure);
    // Enforce security requirements for __Host- prefix
    return Cookies.set(cookieName, value, {
      path: '/',
      secure: secure,
      sameSite: sameSite,
      httpOnly: httpOnly,
    });
  };

export const removeCookie = (name, secure = false) => {
  Cookies.remove(getPrefixedName(name, secure), { path: '/' });
};